import { BusinessLineEnum, BusinessLineLabels } from '@/bundles/Pipelines/types';

export const FilterBusinessLineAll = 'all' as const;

export type FilterBusinessLine = BusinessLineEnum | typeof FilterBusinessLineAll;

export const FilterBusinessLineLabels: Record<FilterBusinessLine, string> = {
  ...BusinessLineLabels,
  [FilterBusinessLineAll]: 'All',
};

export const FilterBusinessLineItems = [
  {
    text: FilterBusinessLineLabels[BusinessLineEnum.brokerage],
    value: BusinessLineEnum.brokerage,
  },
  {
    text: FilterBusinessLineLabels[FilterBusinessLineAll],
    value: FilterBusinessLineAll,
  },
  {
    text: FilterBusinessLineLabels[BusinessLineEnum.property_management],
    value: BusinessLineEnum.property_management,
  },
];
